<template>
  <div ref="slider" class="custom-slider minmax">
    <input
      type="range"
      name="min"
      id="min"
      :min="localMin"
      :max="localMax"
      :value="sliderMinValue"
      :step="localStep"
      @input="onMinValueChanged"
    />
    <input
      type="range"
      name="max"
      id="max"
      :min="localMin"
      :max="localMax"
      :value="sliderMaxValue"
      :step="localStep"
      @input="onMaxValueChanged"
    />
  </div>
  <div class="minmax-inputs">
    <input type="number" :step="localStep" v-model="sliderMinValue" style="color: #403d70; font-weight: bold; width: 80px;"/>
    <input type="number" :step="localStep" v-model="sliderMaxValue" style="color: #403d70; font-weight: bold; width: 80px; text-align: right;" />
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits, computed } from "vue";
import axios from "axios";

const props = defineProps(["min", "max", "step", "minValue", "maxValue"]);
const sliderMinValue = ref(props.minValue);
const sliderMaxValue = ref(props.maxValue);
const emits = defineEmits(["update:minValue", "update:maxValue"]);

const localMin = computed(() => props.min);
const localMax = computed(() => props.max);
const localStep = computed(() => props.step);

const onMinValueChanged = (event) => {
    sliderMinValue.value = parseFloat(event.target.value);
    emits("update:minValue", sliderMinValue.value);
};

const onMaxValueChanged = (event) => {
    sliderMaxValue.value = parseFloat(event.target.value);
    emits("update:maxValue", sliderMaxValue.value);
};

onMounted(async () => {
    var token = localStorage.getItem('xperttoken');
    var customerselected = localStorage.getItem('xpertcustomerselected');

    // Set the authorization header with the bearer token
    const instance = axios.create({
        baseURL: 'https://offer.xpertbooking.be/api/v1',
        headers: {
          Authorization: `Bearer ${token}`,
          'Customer': customerselected,
        }
    });

    const response = await instance.get('/slidervalues');
    console.log('slider');
    console.log(response);
    
    localMin.value = sliderMinValue.value = response.data.minValue;
    localMax.value = sliderMaxValue.value = response.data.maxValue;
});
</script>

<style>
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }

        /* Firefox */
        input[type=number] {
        -moz-appearance: textfield;
        }

        .slider-cont {
        width: 300px;
        }

        .custom-slider {
        --trackHeight: 0.35rem;
        --thumbRadius: 1rem;
        }

        /* style the input element with type "range" */
        .custom-slider input[type="range"] {
        position: relative;
        appearance: none;
        background: none;
        border-radius: 999px;
        z-index: 0;
        height: 100%;
        pointer-events: none;
        }

        /* ::before element to replace the slider track */
        .custom-slider input[type="range"]::before {
        content: "";
        display: block;
        position: absolute;
        width: var(--ProgressPercent, 100%);
        height: 100%;
        background: #403d70;
        border-radius: 999px;
        }

        /* `::-webkit-slider-runnable-track` targets the track (background) of a range slider in chrome and safari browsers. */
        .custom-slider input[type="range"]::-webkit-slider-runnable-track {
        appearance: none;
        background: #403d70;
        height: var(--trackHeight);
        border-radius: 999px;
        }

        .custom-slider input[type="range"]::-webkit-slider-thumb {
        position: relative;
        width: var(--thumbRadius);
        height: var(--thumbRadius);
        margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
        background: #403d70;
        border: 1px solid  #403d70;
        border-radius: 999px;
        pointer-events: all;
        appearance: none;
        z-index: 1;
        }

        /* `::-moz-range-track` targets the track (background) of a range slider in Mozilla Firefox. */
        .custom-slider.default input[type="range"]::-moz-range-track {
        appearance: none;
        background: #403d70;
        height: var(--trackHeight);
        border-radius: 999px;
        }

        .custom-slider input[type="range"]::-moz-range-thumb {
        position: relative;
        box-sizing: border-box;
        width: var(--thumbRadius);
        height: var(--thumbRadius);
        margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
        background: #403d70;
        border: 1px solid  #403d70;
        border-radius: 999px;
        pointer-events: all;
        appearance: none;
        z-index: 1;
        }

        .custom-slider.minmax {
        position: relative;
        height: var(--trackHeight);
        background: #403d70;
        border-radius: 999px;
        margin: 0.5rem 0;
        --progressLeft: 0%;
        --progressRight: 0%;
        }

        .custom-slider .minmax-indicator {
        position: absolute;
        height: 100%;
        pointer-events: none;
        left: var(--thumbRadius);
        right: var(--thumbRadius);
        }

        .custom-slider .minmax-indicator::before {
        content: "";
        position: absolute;
        background: #403d70;
        height: 100%;
        left: var(--progressLeft);
        right: var(--progressRight);
        }

        .custom-slider.minmax input[type="range"] {
        position: absolute;
        width: calc(100% - var(--thumbRadius));
        }

        .custom-slider.minmax input[type="range"][name="max"] {
        left: var(--thumbRadius);
        }

        .custom-slider.minmax input[type="range"]::-webkit-slider-runnable-track {
        background: none;
        }

        .custom-slider.minmax input[type="range"]::before {
        display: none;
        }

        .minmax-inputs {
        display: flex;
        justify-content: space-between;
        }

        .minmax-inputs input {
        width: 50px;
        }
</style>